import { render, staticRenderFns } from "./ProcessBadge.vue?vue&type=template&id=55ee85db&scoped=true"
import script from "./ProcessBadge.vue?vue&type=script&lang=js"
export * from "./ProcessBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ee85db",
  null
  
)

export default component.exports